/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Suspense } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import './LandingPage.scss';
import { withAuth } from 'src/hocs/withAuth';
import { useTranslation } from 'react-i18next';
import landingImageMemberPortal from '../../img/landingPage/Icon-Member.svg';
import landingImageAdminPortal from '../../img/landingPage/Icon-Employer.svg';
import AppleStoreImage from '../../img/Appstore.svg';
import GooglePlayImage from '../../img/googleplay.svg';

library.add(faExclamationCircle);
const Header = React.lazy(() => import('./header'));
const Footer = React.lazy(() => import('./footer'));

const LandingPage = () => {
  const { t } = useTranslation();
  return (
    <div className="landing-page-background">
      <Suspense fallback={<i className="fa-li fa fa-spinner fa-spin"></i>}>
        <Header />
      </Suspense>
      <div>
        <Container className="content-area">
          <Row>
            <Col>
              <Row>
                <Col md={6} lg={6} sm={12} xs={12} className="main-heading">
                  <h1 className="m-0">{t('landing_page.main_heading')}</h1>
                  <span>{t('landing_page.insurance_experience')}</span>
                </Col>
              </Row>
              <Row>
                <Col md={4} lg={4} sm={12} xs={12} className="mt-3">
                  <p className="normal-text">{t('landing_page.normal_text')}</p>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="center-cards mt-4">
            <Col>
              <h3>{t('landing_page.who_i_am')}</h3>
              <Row className="mt-4">
                <Col md={4} lg={4} sm={12} xs={12}>
                  <Link to="/member" className="landingpage-member-hover">
                    <div className="custom-card">
                      <h3>{t('landing_page.mem_dep')}</h3>
                      <Row>
                        <Col md={6} lg={7} sm={6} xs={6}>
                          <p className="normal-text pt-3">
                            {t('landing_page.member_note')}
                          </p>
                        </Col>
                        <Col md={6} lg={5} sm={6} xs={6}>
                          <img
                            src={landingImageMemberPortal}
                            alt="logo"
                            className="mt-5"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Link>
                </Col>

                <Col md={4} lg={4} sm={12} xs={12} className="mt-5 mt-sm-0">
                  <Link to="/admin" className="landingpage-member-hover">
                    <div className="custom-card">
                      <h3>{t('landing_page.mem_admin')}</h3>
                      <Row>
                        <Col md={6} lg={7} sm={6} xs={6}>
                          <p className="normal-text pt-3">
                            {t('landing_page.admin_note')}
                          </p>
                        </Col>
                        <Col md={6} lg={5} sm={6} xs={6}>
                          <img
                            src={landingImageAdminPortal}
                            alt="logo"
                            className="mt-5"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="mt-4 align-items-center mobile-app-section mb-5">
            <Col md={7} sm={7} xs={12}>
              <h4 className="mt-2 mb-2">{t('landing_page.mobile_app')}</h4>
              <p className="pt-3 ormal-text">{t('landing_page.mobile_note')}</p>
            </Col>
            <Col md={5} sm={5} xs={12} className="mt-5 mt-sm-0">
              <Row>
                <Col className="col-md-6 col-sm-6 col-xs-6">
                  <a
                    target="_blank"
                    rel="noreferrer noopener"
                    href="https://www.apple.com/app-store"
                  >
                    <img
                      src={AppleStoreImage}
                      title="Appstore"
                      alt="app-store"
                      style={{ width: 'auto', height: '44px' }}
                    />
                  </a>
                </Col>
                <Col className="col-md-6 col-sm-6 col-xs-6">
                  <a
                    target="_blank"
                    rel="noreferrer noopener"
                    href="https://play.google.com/store"
                  >
                    <img
                      src={GooglePlayImage}
                      title="Googleplay"
                      alt="googleplay"
                      style={{ width: 'auto', height: '44px' }}
                    />
                  </a>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      <Suspense fallback={<i className="fa-li fa fa-spinner fa-spin"></i>}>
        <Footer />
      </Suspense>
    </div>
  );
};
export default withAuth(LandingPage);
